import React from 'react';
import moment from 'moment';
import classnames from 'classnames';

import MyTag from '../my-tag';
import style from './index.less';
// 智能引导
const MessageEventIntGuidance = props => {
  const { data } = props;
  const {
    time,
    content: { title, answers, cardFields }
  } = data;
  const date = moment
    .utc(time)
    .local()
    .format('MM/DD HH:mm:ss');

  const hasCardFiled = cardFields && cardFields.length > 0;
  return (
    <div className={style['guidance-box']}>
      <ul className={classnames(style.header, style['guidance-header'])}>
        <li>{title}</li>
        <li className={style.date}>{date}</li>
      </ul>
      <div className={style['evaluation-content']}>
        {answers.map((answer, ind) => {
          const { label, value } = answer;
          let text = '';
          if (typeof value === 'string' || typeof value === 'number') {
            text = value;
          }
          return (
            <div key={ind}>
              <div className={style['guidance-row']}>问：{label}</div>
              <div className={classnames(style['guidance-row'], style['guidance-answer'])}>答：{text}</div>
            </div>
          );
        })}
      </div>
      {hasCardFiled && (
        <>
          <div className={style['guidance-border']} />
          <div className={style['guidance-clue']}>
            <span className={style['guidance-label']}>已获取：</span>
            {cardFields.map((answer, ind) => {
              const { label } = answer;
              return (
                <MyTag.BorderTag color="tag-mpush-tag" key={ind} className={style.clue}>
                  {label}
                </MyTag.BorderTag>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default MessageEventIntGuidance;
